import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../services/api';

export default function Login() {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const handleLogin = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');
        try {
            const res = await api.post('/api/auth/login', { email, password });
            localStorage.setItem('synapse_token', res.data.token);
            navigate('/dashboard');
        } catch (err) {
            setError('Credenciais invalidas');
        }
        setLoading(false);
    };

    return (
        <div style={{ minHeight:'100vh', display:'flex', alignItems:'center', justifyContent:'center', background:'var(--bg-primary)' }}>
            <div style={{ background:'var(--bg-secondary)', border:'1px solid var(--border)', borderRadius:'var(--radius-lg)', padding:48, width:400, textAlign:'center' }}>
                <div style={{ marginBottom:12 }}>
                    <img src="/synapse-logo.svg" alt="Synapse" style={{ width:72, height:72 }} />
                </div>
                <h1 style={{ fontFamily:"'Space Grotesk', sans-serif", fontSize:28, fontWeight:700, letterSpacing:4, marginBottom:4 }}>SYNAPSE</h1>
                <p style={{ color:'var(--text-muted)', fontSize:13, marginBottom:32 }}>by Neurotech-X</p>
                <form onSubmit={handleLogin}>
                    <div className="form-group"><input type="email" placeholder="Email" value={email} onChange={e=>setEmail(e.target.value)} required/></div>
                    <div className="form-group"><input type="password" placeholder="Senha" value={password} onChange={e=>setPassword(e.target.value)} required/></div>
                    {error && <p style={{ color:'var(--red-500)', fontSize:13, marginBottom:16 }}>{error}</p>}
                    <button type="submit" className="btn-primary" disabled={loading} style={{ width:'100%', padding:'12px', fontSize:15 }}>{loading?'Entrando...':'Entrar'}</button>
                </form>
            </div>
        </div>
    );
}
